import React from 'react';
import NotImplemented from '../NotImplemented';
import SideNavLayout from './SideNavLayout';
import { variant1, variant2, variant3, variant4, variant5 } from './service/constants';
import {
  HONDA_SITE_NAME,
  ACURA_SITE_NAME,
  ATV_PRODUCT_NAME,
  PSP_SITE_NAME,
  MARINE_SITE_NAME,
  PE_SITE_NAME,
} from '../../utils/constants';
import useAppName from '../../utils/sitecoreContext/useAppName';

const SideNavLayoutWrapper = props => {
  const appName = useAppName();
  const { rendering } = props;

  let variant;
  switch (appName) {
    case HONDA_SITE_NAME:
      variant = variant1;
      break;
    case ACURA_SITE_NAME:
      variant = variant2;
      break;
    case ATV_PRODUCT_NAME:
      variant = variant3;
      break;
    case PSP_SITE_NAME:
    case MARINE_SITE_NAME:
      variant = variant4;
      break;
    case PE_SITE_NAME:
      variant = variant5;
      break;
    default:
      return <NotImplemented name={rendering?.componentName} />;
  }
  return <SideNavLayout {...props} variant={variant} />;
};
export default SideNavLayoutWrapper;
